
import { Component,Prop, BaseMixins,Watch } from '@/lib';
@Component({name:"query-result"})
export default class QueryResult extends BaseMixins{
    /*store table 默认根据query解析*/
    @Prop({type:String, default:"table"}) resultFieldName:any;
    /*列数组*/
    @Prop({type:Array, default:() => { return []}}) cols:Array<any>;

    /*查询dispatch type     module/menu/action*/
    @Prop({ type: String, required: true }) queryAction: string; 

    /*action buttons*/
    @Prop({type: Array}) buttons:Array<any>;
    /*是否显示 checkbox*/
    @Prop({type:Boolean, default:false}) selection: boolean;
    /*是否fixed*/
    @Prop({type:Boolean, default:false}) fixed: boolean;
     /*是否显示间隔斑马纹*/
  @Prop({ type: Boolean, default: false }) stripe: boolean;
  /*序号宽度*/
  @Prop({ type: Number, default: 60 }) indexWidth: number;
   @Prop({type:Function}) summaryMethod:any;
   @Prop({type:Function}) sortion:any;

    get tableData(){
      let arr = this.queryAction.split("/");
      return this.$store.state[arr[0]][arr[1]][this.resultFieldName];
    }

    get columns(){
        let prefix = [];
        if(this.selection){
            prefix = [ { type:"selection", width:60, align:"center", fixed:this.fixed?"left":"" }];
        }
        return [ {title:"#", slot:"index", width:this.indexWidth, align:"right", fixed:this.fixed?"left":""},...prefix,...this.cols]
    }

    getIndex(index:number){
       return (this.tableData.currentPage - 1) * this.tableData.pageSize + index + 1;
    }

    selectionChange(selection){
        this.$emit("on-selection-change", selection)
    }
}    
